module.exports = __webpack_public_path__ + "static/img/7.4b0fcf5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/7.png
// module id = lZss
// module chunks = 0